import { ModelController } from "@/controllers/model-controllers/abstract/model-controller"
import { type ModelConstructorSignature } from "@/models/types/model-constructor-signature"
import { type IStoreFunctionsConfig } from "@/store/base-functions/base-store-functions"
import { GenericAPIFunctions } from "@/api/generic-api-functions"
import { GenericStoreFunctions } from "@/store/base-functions/generic-store-functions"
import { BaseModel } from "@/models/base.model"
import { type IBase } from "@/interfaces/api/base.interface"
import { BaseRepository } from "@/repositories/base-repository"

export class GenericModelController<
  Model extends BaseModel,
  IData extends IBase,
  Repository extends BaseRepository<IData>
> extends ModelController<Model, IData, Repository> {
  protected constructor(
    modelType: ModelConstructorSignature<IData, Model>,
    storeFunctionsConfig: IStoreFunctionsConfig<Model>,
    repository: Repository
  ) {
    super(
      new GenericAPIFunctions(repository),
      new GenericStoreFunctions(modelType, storeFunctionsConfig)
    )
  }
}
